import script from "./application-process-stage.vue?vue&type=script&setup=true&lang=ts"
export * from "./application-process-stage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__